import * as yup from 'yup'

export const addInstitutionSchema = yup.object({
	name: yup.string().required(),
})
